function Spinner() {
  return (
    <div className="absolute inset-0 z-10 bg-white bg-opacity-75">
      <svg className="ai-loader ai-loader--centered" viewBox="0 0 50 50" aria-hidden="true">
        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
      </svg>
    </div>
  )
}

export default Spinner
